import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import {
  Col,
  Row,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  Collapse,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import Config from "config";
import { FiChevronUp, FiChevronDown } from "react-icons/fi";
import { makeSelectStyles } from "../../common/selectStyles";

function EditTypePublipostage() {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  let { id } = useParams();
  const navigate = useNavigate();
  const layout = localStorage.getItem("layoutMode");

  const [loading, setLoading] = useState(true);
  const [wait, setWait] = useState(1000);
  const token = localStorage.getItem("auth_token_" + api);
  const [configData, setConfigData] = useState([]);
  const [activeTab, setActiveTab] = useState("details");
  const [isIdentificationAccordionOpen, setIsIdentificationAccordionOpen] =
    useState(true);
  const toggleIdentificationAccordion = () => {
    setIsIdentificationAccordionOpen(!isIdentificationAccordionOpen);
  };

  const styles = makeSelectStyles(layout);

  // Formulaire
  const [formData, setFormData] = useState({
    "Catégorie": { label: null, value: null },
    "Label": "",
    "Accès investisseur": "",
    "Accès CGP": "",
    "Ordre": "",
  });

  const handleInputChange = (key, value) => {
    setFormData((prevState) => ({ ...prevState, [key]: value }));
  };

  // Données pour les selects
  const [categoriesData, setCategoriesData] = useState({ data: [] });

  const renderSelectOptions = (data) => [
    {
      options: data.map((item) => ({
        label: item.label,
        value: item.value ?? item.id,
      })),
    },
  ];

  const getCategories = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/types_publipostages/categories_documents`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
        .then((response) => response.json())
        .then((result) => {
          setCategoriesData(result);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const getData = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/types_publipostages/${id}/edit`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 403) navigate(`${backUrl}/forbidden`);
      if (response.status === 500) navigate(`${backUrl}/error`);
      if (response.status === 203) navigate(`${backUrl}/error404`);
      if (response.status === 401) {
        localStorage.removeItem("auth_token_" + api);
        localStorage.removeItem("authUser_" + api);
        localStorage.removeItem("sideBar_" + api);
        navigate(`${backUrl}/login`);
        window.location.reload(false);
      }
      const result = await response.json();
      setConfigData(result);

      const identification =
        result?.detail_types_publipostage?.["Identification"] || result || {};

      setFormData((prev) => ({
        ...prev,
        "Catégorie":
          identification["Catégorie du document"] ||
          identification["Catégorie"] ||
          (identification["categories_document_id"]
            ? {
                label:
                  identification["categories_document"] || null,
                value: identification["categories_document_id"],
              }
            : { label: null, value: null }),
        "Label":
          identification["Label"] || identification["label"] || identification["Type de document"] || "",
        "Accès investisseur":
          identification["Accès investisseur"] ??
          identification["acces_investisseur"] ??
          "",
        "Accès CGP":
          identification["Accès CGP"] ?? identification["acces_cgp"] ?? "",
        "Ordre":
          identification["Ordre"] ?? identification["ordre"] ?? "",
      }));
    } catch (error) {
      console.error(error);
    }
  };

  const handleNavigate = () => {
    localStorage.setItem("key", true);
    localStorage.setItem("editSuccess", "true");
    const previousPath = localStorage.getItem("previousPath_" + api);
    navigate(previousPath || -1);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      setLoading(true);
      const body = new FormData();
      body.append("id", id);
      body.append("categories_document_id", formData["Catégorie"]?.value);
      body.append("label", formData["Label"]);
      body.append("acces_investisseur", formData["Accès investisseur"]?.value ?? "");
      body.append("acces_cgp", formData["Accès CGP"]?.value ?? "");
      body.append("ordre", formData["Ordre"]);

      const response = await fetch(
        `https://www.fluxod.com/${api}/types_publipostages/${id}`,
        {
          method: "PATCH",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body,
        }
      );

      if (response.ok) {
        handleNavigate();
      } else {
        const responseData = await response.json();
        if (responseData?.message_validation) {
          responseData.message_validation.forEach((err) => toast.error(err));
        } else {
          toast.error("Une erreur s'est produite");
        }
        setLoading(false);
      }
    } catch (error) {
      console.error("An error occurred", error);
      toast.error("Une erreur s'est produite");
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        await getData();
        getCategories();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  document.title = "Type doc fusion | Edit";

  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            onClick={() => setActiveTab("details")}
          >
            Détails type de publipostage
          </NavLink>
        </NavItem>
      </Nav>
    );
  };

  const OuiNon = {
    data: [
      { id: 1, label: "Oui" },
      { id: 2, label: "Non" },
    ],
  };
  const renderOuiNonOptions = () => {
    return [
      {
        options: OuiNon.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  const fieldStyle = {
    backgroundColor: "white",
    transition: "all 0.15s ease",
    borderLeft: "3px solid transparent",
    position: "relative",
  };

  return (
    <>
      <React.Fragment>
        <div className="page-content" style={{ fontFamily: "sans-serif" }}>
          <div className="container-fluid">
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody className="border-bottom">
                    <div className="d-flex align-items-center">
                      <h5
                        className="mb-0 card-title flex-grow-1"
                        style={{ fontWeight: "bold", display: "flex" }}
                      >
                        <Link
                          to={`${backUrl}/types_publipostages/`}
                          style={{
                            color: "#555B21",
                            textDecoration: "underline !important",
                          }}
                        >
                          Type doc fusion
                        </Link>
                        <i className="bx bx-caret-right"></i>
                        {!loading ? (
                          configData?.sil || `#${id}`
                        ) : (
                          <span
                            className="placeholder col-3"
                            style={{ height: "1em" }}
                          ></span>
                        )}
                      </h5>
                    </div>
                    <div className="d-flex justify-content-end">
                      <div className="d-flex align-items-end">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={handleSubmit}
                        >
                          <i className="bx bx-send"></i> Valider
                        </button>
                        &nbsp;&nbsp;
                        <button
                          onClick={() => {
                            const previousPath = localStorage.getItem(
                              "previousPath_" + api
                            );
                            navigate(previousPath || -1);
                          }}
                          className="btn btn-sm btn-soft-secondary"
                          style={{ width: "88.43px" }}
                        >
                          <i className="bx bx-arrow-back"></i> Annuler
                        </button>
                      </div>
                    </div>
                  </CardBody>
                  {CustomNavTabs()}
                  <CardBody>
                    {activeTab === "details" && (
                      <div>
                        {!loading ? (
                          <>
                            <Row>
                              <Col sm="12">
                                <Card
                                  className="shadow-sm border-0 overflow-hidden mb-4"
                                  style={{ borderRadius: "12px" }}
                                >
                                  {/* En-tête */}
                                  <div
                                    className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                    style={{
                                      background: "#555B21",
                                      letterSpacing: "0.5px",
                                      cursor: "pointer",
                                      userSelect: "none",
                                    }}
                                    onClick={toggleIdentificationAccordion}
                                  >
                                    <span style={{ fontSize: "0.82rem" }}>
                                      Identification
                                    </span>
                                    {isIdentificationAccordionOpen ? (
                                      <FiChevronUp size={16} />
                                    ) : (
                                      <FiChevronDown size={16} />
                                    )}
                                  </div>

                                  <Collapse
                                    isOpen={isIdentificationAccordionOpen}
                                  >
                                    <CardBody className="p-0">
                                      <div
                                        className="fields-container"
                                        style={{ paddingBottom: "8px" }}
                                      >
                                        {/* Catégorie du document */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={fieldStyle}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              className="field-label"
                                            >
                                              <div
                                                className="d-flex align-items-center small text-muted"
                                                style={{
                                                  minWidth: 0,
                                                  gap: "4px",
                                                }}
                                              >
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.7rem",
                                                    letterSpacing: "0.2px",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                    minWidth: 0,
                                                    flex: "1 1 auto",
                                                    display: "block",
                                                  }}
                                                  title="Catégorie du document"
                                                >
                                                  Catégorie du document
                                                </span>
                                                <span
                                                  className="text-primary"
                                                  style={{
                                                    flexShrink: 0,
                                                    marginLeft: "auto",
                                                  }}
                                                >
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={12} lg={8}>
                                              <Select
                                                value={formData["Catégorie"]}
                                                onChange={(val) =>
                                                  handleInputChange(
                                                    "Catégorie",
                                                    val
                                                  )
                                                }
                                                options={renderSelectOptions(
                                                  categoriesData?.data || []
                                                )}
                                                styles={styles(false)}
                                                classNamePrefix="select2-selection"
                                                menuPortalTarget={document.body}
                                                isClearable
                                                placeholder="Sélectionner..."
                                              />
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Label */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={fieldStyle}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <div
                                            className="field-separator"
                                            style={{
                                              position: "absolute",
                                              top: "0",
                                              left: "0",
                                              right: 0,
                                              height: "1px",
                                              background:
                                                "linear-gradient(90deg, #e9ecef 0%, #e9ecef 20%, #e9ecef 100%, #e9ecef 100%)",
                                            }}
                                          />
                                          <Row className="align-items-center g-1">
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              className="field-label"
                                            >
                                              <div
                                                className="d-flex align-items-center small text-muted"
                                                style={{
                                                  minWidth: 0,
                                                  gap: "4px",
                                                }}
                                              >
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.7rem",
                                                    letterSpacing: "0.2px",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                    minWidth: 0,
                                                    flex: "1 1 auto",
                                                    display: "block",
                                                  }}
                                                  title="Label"
                                                >
                                                  Label
                                                </span>
                                                <span
                                                  className="text-primary"
                                                  style={{
                                                    flexShrink: 0,
                                                    marginLeft: "auto",
                                                  }}
                                                >
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={12} lg={8}>
                                              <input
                                                className="form-control form-control-sm"
                                                type="text"
                                                value={formData["Label"]}
                                                onChange={(e) =>
                                                  handleInputChange(
                                                    "Label",
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Accès investisseur */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={fieldStyle}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <div
                                            className="field-separator"
                                            style={{
                                              position: "absolute",
                                              top: "0",
                                              left: "0",
                                              right: 0,
                                              height: "1px",
                                              background:
                                                "linear-gradient(90deg, #e9ecef 0%, #e9ecef 20%, #e9ecef 100%, #e9ecef 100%)",
                                            }}
                                          />
                                          <Row className="align-items-center g-1">
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              className="field-label"
                                            >
                                              <div
                                                className="d-flex align-items-center small text-muted"
                                                style={{
                                                  minWidth: 0,
                                                  gap: "4px",
                                                }}
                                              >
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.7rem",
                                                    letterSpacing: "0.2px",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                    minWidth: 0,
                                                    flex: "1 1 auto",
                                                    display: "block",
                                                  }}
                                                  title="Accès investisseur"
                                                >
                                                  Accès investisseur
                                                </span>
                                                <span
                                                  className="text-primary"
                                                  style={{
                                                    flexShrink: 0,
                                                    marginLeft: "auto",
                                                  }}
                                                >
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={12} lg={8}>
                                              <Select
                                                value={formData["Accès investisseur"]}
                                                onChange={(val) =>
                                                  handleInputChange(
                                                    "Accès investisseur",
                                                    val
                                                  )
                                                }
                                                options={renderOuiNonOptions()}
                                                styles={styles(false)}
                                                classNamePrefix="select2-selection"
                                                menuPortalTarget={document.body}
                                                isClearable
                                                placeholder="-- Sélectionner --"
                                              />
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Accès CGP */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={fieldStyle}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <div
                                            className="field-separator"
                                            style={{
                                              position: "absolute",
                                              top: "0",
                                              left: "0",
                                              right: 0,
                                              height: "1px",
                                              background:
                                                "linear-gradient(90deg, #e9ecef 0%, #e9ecef 20%, #e9ecef 100%, #e9ecef 100%)",
                                            }}
                                          />
                                          <Row className="align-items-center g-1">
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              className="field-label"
                                            >
                                              <div
                                                className="d-flex align-items-center small text-muted"
                                                style={{
                                                  minWidth: 0,
                                                  gap: "4px",
                                                }}
                                              >
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.7rem",
                                                    letterSpacing: "0.2px",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                    minWidth: 0,
                                                    flex: "1 1 auto",
                                                    display: "block",
                                                  }}
                                                  title="Accès CGP"
                                                >
                                                  Accès CGP
                                                </span>
                                                <span
                                                  className="text-primary"
                                                  style={{
                                                    flexShrink: 0,
                                                    marginLeft: "auto",
                                                  }}
                                                >
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={12} lg={8}>
                                              <Select
                                                value={formData["Accès CGP"]}
                                                onChange={(val) =>
                                                  handleInputChange(
                                                    "Accès CGP",
                                                    val
                                                  )
                                                }
                                                options={renderOuiNonOptions()}
                                                styles={styles(false)}
                                                classNamePrefix="select2-selection"
                                                menuPortalTarget={document.body}
                                                isClearable
                                                placeholder="-- Sélectionner --"
                                              />
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Ordre */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={fieldStyle}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <div
                                            className="field-separator"
                                            style={{
                                              position: "absolute",
                                              top: "0",
                                              left: "0",
                                              right: 0,
                                              height: "1px",
                                              background:
                                                "linear-gradient(90deg, #e9ecef 0%, #e9ecef 20%, #e9ecef 100%, #e9ecef 100%)",
                                            }}
                                          />
                                          <Row className="align-items-center g-1">
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              className="field-label"
                                            >
                                              <div
                                                className="d-flex align-items-center small text-muted"
                                                style={{
                                                  minWidth: 0,
                                                  gap: "4px",
                                                }}
                                              >
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.7rem",
                                                    letterSpacing: "0.2px",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                    minWidth: 0,
                                                    flex: "1 1 auto",
                                                    display: "block",
                                                  }}
                                                  title="Ordre"
                                                >
                                                  Ordre
                                                </span>
                                                <span
                                                  className="text-primary"
                                                  style={{
                                                    flexShrink: 0,
                                                    marginLeft: "auto",
                                                  }}
                                                >
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={12} lg={8}>
                                              <input
                                                className="form-control form-control-sm"
                                                type="number"
                                                value={formData["Ordre"]}
                                                onChange={(e) =>
                                                  handleInputChange(
                                                    "Ordre",
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            </Col>
                                          </Row>
                                        </div>
                                      </div>
                                    </CardBody>
                                  </Collapse>
                                </Card>
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <Spinners setLoading={setLoading} setWait={wait} />
                        )}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
        <ToastContainer />
      </React.Fragment>
    </>
  );
}

export default EditTypePublipostage;
